'use strict'
module.exports = {
  NODE_ENV: '"production"',
  BASE_API: '"https://puyang.wengegroup.com/activities"',
  ZPJ_API:'https://www.pyxxww.com:29503'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1